import { init as initApm } from '@elastic/apm-rum'

export default {
  init: () => {
    initApm({
      serviceName: 'seminovos-admin-frontend',
      serverUrl: 'https://apm.carmi.com.br:443',
      environment: process.env.REACT_APP_APM_ENV
    })
  }
}
